module.exports = __webpack_public_path__ + "static/media/ic-rockx-logo.978ceedf.svg";